import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { DataGrid } from '@mui/x-data-grid';
import Swal from 'sweetalert2';
import {Link, useParams} from 'react-router-dom';

import AutoComplete from '@mui/material/Autocomplete';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function IpPatView(props){

  const {ip_id} = useParams();
  const [inputValue, setInputValue] = useState('');
  const [ipData, setIpData] = useState([]);
  const [labData, setLabData] = useState([]);
  const [drugData, setDrugData] = useState([]);
  const [invData, setInvData] = useState([]);
  const [minviewData, setMinviewData] = useState([]);
  const [totData, setTotData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [advData, setAdvData] = useState([]);
  const [insurData, setInsurData] = useState([]);
  const [iprefundData, setIprefundData] = useState([]);
  const [selectedDateTime, setSelectedDateTime] = useState(new Date());
  const [disPer, setDisPer] = useState(0);
  const [disAmount, setDisAmount] = useState(0);
  const [minitems, setminItems] = useState([]);
  const [minrows, setminRows] = useState([{ ID: '', Subcat: '', Amount: '' }]);
  const [mintotal, setminTotal] = useState(0);
  const [minsubtotal, setminsubTotal] = useState(0);
  const [mindisPer, setmindisPer] = useState(0);
  const [mindisAmount, setmindisAmount] = useState(0);
  const [viewPharmData, setViewPharmData] = useState([]);
  const [minData,setminData]=useState({
        "appt_id":'',
        "ip":'',
        "pat":'',
        "cons":'',
        "min_id":'',
        "min_test":'',
        "min_units":'',
        "min_amount":'',
        "min_tot":'',
        "min_disc":'',
        "min_status":'',
        "addedby":'',
        "ip_add":'',
    });

    const handleDateTimeChange = (datetime) => {
        setSelectedDateTime(datetime);
    };

  useEffect(() => {
    fetchData();
  }, []);

  function fetchData() {
    axios.get(baseUrl + "edit-ip-admit/" + ip_id + "/")
      .then(response => {
        setIpData([response.data]);
      })
      .catch(error => {
        console.log(error);
      });
  }
const room_no = ipData.map(row => row.room_no.id);
  useEffect(() => {
    fetchMinData();
  }, []);

  function fetchMinData() {
    axios.get(`${baseUrl}min-search/`)
      .then((minResponse) => {
        setminItems(minResponse.data);
      })
      .catch(error => {
        console.log(error);
      });
  }
  useEffect(() => {
    fetchTotData();
  }, []);

  function fetchTotData() {
    axios.get(`${baseUrl}view-ip-tot/${ip_id}`)
      .then((totResponse) => {
        setTotData(totResponse.data);
      })
      .catch(error => {
        console.log(error);
      });
  }
  useEffect(() => {
    fetchadvData();
  }, []);

  function fetchadvData() {
    axios.get(`${baseUrl}view-ip-adv/${ip_id}`)
      .then((advResponse) => {
        setAdvData(advResponse.data);
      })
      .catch(error => {
        console.log(error);
      });
  }
  useEffect(() => {
    fetchinsurData();
  }, []);

  function fetchinsurData() {
    axios.get(`${baseUrl}view-pre-insur/${ip_id}`)
      .then((insResponse) => {
              const filteredData = insResponse.data.filter(item => item.status == 3);
              setInsurData(filteredData);
      })
      .catch(error => {
        console.log(error);
      });
  }
  useEffect(() => {
    fetchdrugData();
  }, []);

  function fetchdrugData() {
    axios.get(`${baseUrl}view-ip-drug/${ip_id}`)
      .then((drugResponse) => {
        setDrugData(drugResponse.data);
      })
      .catch(error => {
        console.log(error);
      });
  }

       useEffect(() => {
      if (drugData.length > 0) {
        fetchPhData();
      }
    }, [drugData]);

function fetchPhData() {
  const ipIds = drugData.map(row => row.product.split(',').map(item => item.trim()));

  ipIds.forEach(ipId => {
    try {
      ipId.forEach(id => {
        axios.get(baseUrl + 'update-indent-use-bill/' + id + '/')
          .then(function (response) {
            const data = Object.assign({}, response.data);
            setViewPharmData(prevData => [...prevData, data]);
          })
          .catch(function (error) {
            console.log(error);
          });
      });
    } catch (error) {
      console.log(error);
    }
  });
}

  useEffect(() => {
    fetchlabData();
  }, []);

  function fetchlabData() {
    axios.get(`${baseUrl}view-ip-lab/${ip_id}`)
      .then((labResponse) => {
        setLabData(labResponse.data);
      })
      .catch(error => {
        console.log(error);
      });
  }
  useEffect(() => {
    fetchinvData();
  }, []);

  function fetchinvData() {
    axios.get(`${baseUrl}view-ip-inv/${ip_id}`)
      .then((invResponse) => {
        setInvData(invResponse.data);
      })
      .catch(error => {
        console.log(error);
      });
  }
  useEffect(() => {
    fetchminviewData();
  }, []);

  function fetchminviewData() {
    axios.get(`${baseUrl}view-ip-min/${ip_id}`)
      .then((minviewResponse) => {
        setMinviewData(minviewResponse.data);
      })
      .catch(error => {
        console.log(error);
      });
  }
  useEffect(() => {
      fetchIprefData();
  }, []);

  async function fetchIprefData() {
      try {
          const iprefResponse = await axios.get(`${baseUrl}view-ip-refund/${ip_id}`);
          const status = (iprefResponse.data[0].refund_status);
          if(status == 2){
          setIprefundData(iprefResponse.data);
          }
      } catch (error) {
        console.log(error);
      }
  }

  const handleKeyDownmin = (e, index) => {
      const newminRows = [...minrows];
      switch (e.keyCode) {
        // Handle Shift key
        case 16:
          e.preventDefault();
          if (index === minrows.length - 1) {
            newminRows.push({ id:'', comp: '', amount: '' });
          }
          break;
        // Handle arrow up key
        case 38:
          e.preventDefault();
          if (newminRows[index].selectedItemmin === 0) {
            newminRows[index].selectedItemmin = minitems.length - 1;
          } else {
            newminRows[index].selectedItemmin--;
          }
          setminRows(newminRows);
          break;
        // Handle arrow down key
        case 40:
          e.preventDefault();
          if (newminRows[index].selectedItemmin === minitems.length - 1) {
            newminRows[index].selectedItemmin = 0;
          } else {
            newminRows[index].selectedItemmin++;
          }
          setminRows(newminRows);
          break;
        default:
          break;
      }
      setminRows(newminRows);
    };

 const handleSelectmin = (val, index) => {
     if (val === undefined || val === null) {
     const newminRows = [...minrows];
     newminRows[index] = { id: '', comp: '', amount: '' };
      setminRows(newminRows);
     } else {
    const selectedItemmin = minitems.find(item => item.comp === val);
    if (selectedItemmin) {
    const newminRows = [...minrows];
    newminRows[index] = {
      id: selectedItemmin.id,
      comp: selectedItemmin.comp,
      amount: selectedItemmin.amount
    };
    setminRows(newminRows);
    }
  }
  };


      const handleAddRowmin = () => {
        const newminRows = [...minrows, { id: '', comp: '', amount: '' }];
        setminRows(newminRows);
      };

  const inputminRefs = useRef([]);

  useEffect(() => {
      inputminRefs.current[inputminRefs.current.length - 1]?.focus();
  }, [minrows]);

  const handleDeleteRowmin = (index) => {
    const newminRows = [...minrows];
    newminRows.splice(index, 1);
    setminRows(newminRows);
  };


  const handleminDisPerChange = (e) => {
   const newmindisPer = parseFloat(e.target.value) || 0;
   setmindisPer(newmindisPer);
  };


  useEffect(() => {
    let minsubTotal = 0;
    let mindisAmount = 0;

    let newminTotal = 0;
    for (let i = 0; i < minrows.length; i++) {
      const row = minrows[i];
      minsubTotal += row.gt;
      mindisAmount = minsubTotal * ( parseFloat(mindisPer) /100 );
      newminTotal = minsubTotal - mindisAmount;
    }
    setminsubTotal(minsubTotal);
    setmindisPer(mindisPer);
    setmindisAmount(mindisAmount);
    setminTotal(newminTotal);
  }, [minrows, mindisPer]);

 const handleAmountChangemin = (e, index) => {
  const newminRows = [...minrows];
  newminRows[index].minunits = 1;
  newminRows[index].amount = parseFloat(e.target.value) || 0; // Update amount instead of minunits
  const gt = newminRows[index].minunits * newminRows[index].amount;
  newminRows[index].gt = gt;
  setminRows(newminRows);
};
const handleunitChange = (e, index) => {
  const newminRows = [...minrows];
  newminRows[index].minunits = parseFloat(e.target.value) || 1;
  const gt = newminRows[index].minunits * newminRows[index].amount;
  newminRows[index].gt = gt;
  setminRows(newminRows);
};


const handleminChange = (e, index) => {
  const { name, value } = e.target;

  setminRows(prevminRows => {
    const newMinRows = [...prevminRows];
    newMinRows[index][name] = value;

    return newMinRows;
  });
};

  const formSubmitmin = (e) => {
      e.preventDefault();
          axios.post(`${baseUrl}get_appt_min_number/`)
          .then(response => {
          const appt_min = response.data.value;
          const _formData = new FormData();
          _formData.append('appt_id', appt_min);
          _formData.append('ip', ip_id);
          _formData.append('pat', ipData.map(row => row.pat.id));
          _formData.append('cons', ipData.map(row => row.primary_consult.id));
          _formData.append('min_id', minrows.map(row => row.id).join(','));
          _formData.append('min_test', minrows.map(row => row.comp).join(','));
          _formData.append('min_units', minrows.map(row => row.minunits).join(','));
          _formData.append('min_amount', minrows.map(row => row.amount).join(','));
          _formData.append('min_tot', mintotal);
          _formData.append('min_disc', mindisAmount.toString());
          _formData.append('min_status', '1');
          _formData.append('addedby', userName);
          _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);

          axios.post(`${baseUrl}ip-min-create/`, _formData)
            .then(response => {
              if(response.status==200 || response.status==201){
                Swal.fire({
                  title: 'min entry has been added.',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setminData({
                  ip_id: '',
                  pat: '',
                  cons: '',
                  min_id: '',
                  ltest_id: '',
                  min_test: '',
                  min_amount: '',
                  min_tot: '',
                  min_disc: '',
                  min_status: '',
                  addedby: '',
                  ip_add: '',
                });
                setminRows([{ id: '', comp: '', amount: '' }]);
                setminTotal(0);
                setminsubTotal(0);
                setmindisPer(0);
                setmindisAmount('');
                setTimeout(() => {
                  window.location.href = '/ip-pat-view/'+ ip_id +'/';
                }, 3000);
              }
            })
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed to add min entry. Please try again later.',
                'error'
              );
            });
        })
        .catch(error => {
          console.log(error);
          Swal.fire(
            'Error!',
            'Failed to generate unique value. Please try again later.',
            'error'
          );
        });
  };
  const dischargeHandler = (e) => {
      e.preventDefault();
          const _formData = new FormData();
          const discharge_type = document.getElementById("discharge_type").value;
          _formData.append('status', '3');
          _formData.append('discharge_time', selectedDateTime.toISOString());
          _formData.append('discharge_type', discharge_type);
          _formData.append('discharge_status', '1');
          axios.post(baseUrl + "update-ip-discharge/" + ip_id + '/', _formData)
            .then(response => {
              if(response.status==200 || response.status==201){
                 _formData.append('status',1);
                _formData.append('ip_add', ipAddress);
                _formData.append('location', userLocation);
                axios.put(`${baseUrl}edit-room-no/${room_no}/`, _formData)
                .then(response2 => {

                });
                Swal.fire({
                  title: 'Discharge Initiated Successfully',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setTimeout(() => {
                  window.location.href = '/ip-pat-view/'+ip_id+'/';
                }, 3000);
              }})
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed. Please try again later.',
                'error'
              );
            });
  };
  const discountHandler = (e) => {
      e.preventDefault();
          const _formData = new FormData();
          const reason = document.getElementById("reason").value;
          const disAmt = document.getElementById("disAmount").value;
          const IpId = totData[0].id;
          _formData.append('disc_reason', reason);
          _formData.append('tot_disc', disAmt);
          _formData.append('addedby',userName);
          _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);
          axios.put(`${baseUrl}update-ip-tot/${IpId}/`, _formData)
            .then(response => {
              if(response.status==200 || response.status==201){
                Swal.fire({
                  title: 'Discount Given Successfully',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setTimeout(() => {
                  window.location.href = '/ip-pat-view/'+ip_id+'/';
                }, 3000);
              }})
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed. Please try again later.',
                'error'
              );
            });
  };
  const refundHandler = (e) => {
      e.preventDefault();
          const _formData = new FormData();
          const ref_reason = document.getElementById("ref_reason").value;
          const ref_type = document.getElementById("ref_type").value;
          const refAmount = document.getElementById("refAmount").value;
          _formData.append('ip', ip_id);
          _formData.append('reason', ref_reason);
          _formData.append('refund_type', ref_type);
          _formData.append('refund_amount', refAmount);
          _formData.append('refund_status', 1);
          _formData.append('addedby',userName);
          _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);
          axios.post(`${baseUrl}ip-refund/`, _formData)
            .then(response => {
              if(response.status==200 || response.status==201){
                Swal.fire({
                  title: 'Refund Raised Successfully',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setTimeout(() => {
                  window.location.href = '/ip-pat-view/'+ip_id+'/';
                }, 3000);
              }})
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed. Please try again later.',
                'error'
              );
            });
  };
    let drugTotalSum = 0;
    let drugPaidSum = 0;
    for (let i = 0; i < drugData.length; i++) {
      drugTotalSum += parseFloat(drugData[i].total);
      if(drugData[i].mode != 'advance') {
        drugPaidSum += parseFloat(drugData[i].paid) || 0;
      }
    }
    let insurTotalSum = 0;
    for (let i = 0; i < insurData.length; i++) {
      insurTotalSum += parseFloat(insurData[i].app_amount);
    }
    let labTotalSum = 0;
    let labPaidSum = 0;
    for (let i = 0; i < labData.length; i++) {
      labTotalSum += parseFloat(labData[i].lab_tot);
      if(labData[i].lab_pmode != 'advance') {
        labPaidSum += parseFloat(labData[i].lab_paid) || 0;
      }
    }
    let invTotalSum = 0;
    let invPaidSum = 0;
    for (let i = 0; i < invData.length; i++) {
      invTotalSum += parseFloat(invData[i].inv_tot);
      if(invData[i].inv_pmode != 'advance') {
        invPaidSum += parseFloat(invData[i].inv_paid) || 0;
      }
    }
    let advTotalSum = 0;
    let advPaidSum = 0;
    for (let i = 0; i < advData.length; i++) {
      advTotalSum += parseFloat(advData[i].advance);
      advPaidSum += parseFloat(advData[i].paid) || 0;
    }
    let minviewTotalSum = 0;
    for (let i = 0; i < minviewData.length; i++) {
      minviewTotalSum += parseFloat(minviewData[i].min_tot);
    }
    let refTotalSum = 0;
    for (let i = 0; i < iprefundData.length; i++) {
      refTotalSum += parseFloat(iprefundData[i].refund_amount);
    }
    minviewTotalSum = parseFloat(minviewTotalSum) || 0;
    invTotalSum = parseFloat(invTotalSum) || 0;
    labTotalSum = parseFloat(labTotalSum) || 0;
    drugTotalSum = parseFloat(drugTotalSum) || 0;

    const InvoicedTotal = minviewTotalSum + invTotalSum + labTotalSum + drugTotalSum;

    advPaidSum = parseFloat(advPaidSum) || 0;
    drugPaidSum = parseFloat(drugPaidSum) || 0;
    invPaidSum = parseFloat(invPaidSum) || 0;
    labPaidSum = parseFloat(labPaidSum) || 0;
    insurTotalSum = parseFloat(insurTotalSum) || 0;
    refTotalSum = parseFloat(refTotalSum) || 0;

    const PaidTotal = advPaidSum + drugPaidSum + invPaidSum + labPaidSum + insurTotalSum - refTotalSum;

    // Calculate the total discount
    const totdisc = totData.reduce((acc, row) => acc + parseFloat(row.tot_disc || 0), 0);

    // Calculate the BalanceTotal
    const BalanceTotal = PaidTotal - InvoicedTotal + totdisc;

    function handledisChange(event) {
    const { name, value } = event.target;
    if (name === "disPer") {
      setDisPer(parseFloat(value));
      const discountAmount = (PaidTotal * parseFloat(value)) / 100;
      setDisAmount(discountAmount);
    } else if (name === "disAmount") {
      setDisAmount(parseFloat(value));
      const discountPercentage = (parseFloat(value) / PaidTotal) * 100;
      setDisPer(discountPercentage);
    }
  }
const discharge_status = ipData.map(row => row.discharge_status);

    return (
    <section className="container mt-4">
     <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-stethoscope" aria-hidden="true" style={{ color: 'red' }}></i>
      Primary Consultant -  Dr.{ipData.map(row => row.primary_consult.consultant)}
      <Link to={`/ip-advance/${ip_id}`} className="btn btn-danger ms-1">
          Adv Request
        </Link>
        <Link to={`/ip-pat-print/${ip_id}`} className="btn btn-success ms-1">
          Admit Card
        </Link>
        <Link to={`/ward-change/${ip_id}`} className="btn btn-info ms-1">
          Ward Change
        </Link>
    </h3>
    <div className="table-responsive">
    <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Patient</th>
          <th>IP ID</th>
          <th>Patient ID</th>
          <th>Patient Name</th>
          <th>Gender</th>
          <th>D.O.B/Age</th>
          <th>Mobile</th>
          <th>Regd. On</th>
          <th>Room Details</th>
        </tr>
      </thead>

      <tbody>
        {ipData.map((patientData, index) => (
          <tr >
          <td><img src={patientData.profile_pic} alt="Thumbnail" className="thumbnail" style={{width:120, height:60}}/></td>
            <td>{patientData.ip_id}</td>
            <td>{patientData.pat.pat_id}</td>
            <td>{patientData.pat.patient}</td>
            <td>{patientData.pat.gender}</td>
            <td>{patientData.pat.age}</td>
            <td>{patientData.pat.mobile}</td>
            <td>{ formatDateTime(patientData.admit_date)}</td>
            <td>{patientData.room_no.room.room}/{patientData.room_no.room_no}</td>

          </tr>
        ))}
      </tbody>
    </table>
    </div>
<div>
  <div className='card'>
  <h3 className="card-header text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-indian-rupee-sign" aria-hidden="true" style={{ color: 'red' }}></i>
      Billing Request
    </h3>
    <form>
      <div className="card-body table-responsive">
          <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th style={{width: 80}}>ID</th>
          <th style={{width: 150}}>Min. Test Name</th>
          <th style={{width: 150}}>Units</th>
          <th style={{width: 150}}>Total</th>
          <th style={{width: 150}}>G.Total</th>
          <th style={{width: 80}}>Action</th>
        </tr>
      </thead>

      <tbody>

      {minrows.map((row, index) => (
        <tr key={index}>
        <td>
        <input
            type="text"
            name="ltest_id"
            value={row.id}
            onChange={handleminChange}
            style={{width: 60}}
            readOnly
          />

           </td>
              <td>
                <AutoComplete
                   value={row.comp}
                   options={minitems.map(item => item.comp)}

                  onChange={(event, val) => handleSelectmin(val, index)}
                  onInputChange={(event, newminInputValue) => {
                    // Update input value
                    setminRows(prevminRows => {
                      const updatedminRows = [...prevminRows];
                      updatedminRows[index].comp = newminInputValue;
                      return updatedminRows;
                    });
                  }}
                 onKeyDown={e => handleKeyDownmin(e, index)}
                 renderInput={(params) => (
                  <div ref={params.InputProps.ref}
                  >
                    <input className="form-control" type="text" {...params.inputProps} focused autoFocus

                           style={{
                              width: 250,
                              background: "#F7EEFF",
                              }}
                     />
                  </div>
                )}
                 ref={(el) => inputminRefs.current[index] = el}
                />
              </td>
              <td>
          <input
            type="number"
            className="ms-5 me-5"
            value={row.minunits}
            name="minunits"
            style={{width: 150}}
            onChange={(e) => {
                handleminChange(e, index);
                handleunitChange(e, index);
              }}
            required
          />
          </td>
          <td>
          <input
            type="number"
            className="ms-2 me-5"
            value={row.amount}
            name="amount"
            onChange={(e) => {
                handleminChange(e, index);
                handleAmountChangemin(e, index);
              }}
          />
           </td>
          <td>
          <input
            type="number"
            className="ms-2 me-5"
            value={row.gt}
            name="gt"
            readOnly
          />
           </td>
          <td>
          <button className="btn btn-danger" type="button" onClick={() => handleDeleteRowmin(index)}>Delete</button>
        </td>
        </tr>
      ))}
         </tbody>
      </table>
      <button className="btn btn-success addmore mt-4" type="button" onClick={handleAddRowmin}>Add More</button>
      <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}
        className='ms-5' >
            <div className="form-group"  >
                <label style={{ fontWeight: 'bold' }}>Subtotal: &nbsp;</label>
                <div className="input-group">
                    <div className="input-group-addon me-2 ">&#8377;</div>
                       <input type="number" value={minsubtotal} readOnly/>
                </div>
            </div>
            <div className="form-group mt-3" style={{display:'none'}} >
                <label style={{ fontWeight: 'bold' }}>Discount: &nbsp;</label>
                <div className="input-group">
                    <div className="input-group-addon me-2 ">%</div>
                       <input type="number" value={mindisPer} name="mindisPer" id="mindisPer"
                           onChange={handleminDisPerChange} />
                </div>
            </div>
            <div className="form-group mt-3" style={{display:'none'}} >
                <label style={{ fontWeight: 'bold' }}>Discount Amount: &nbsp;</label>
                <div className="input-group">
                    <div className="input-group-addon me-2 ">&#8377;</div>
                      <input type="number" onChange={handleminChange} name="mindisAmount" id="mindisAmount" value={mindisAmount} />
                </div>
            </div>
            <div className="form-group mt-3" style={{display:'none'}}>
                <label style={{ fontWeight: 'bold' }}>Total: &nbsp;</label>
                <div className="input-group">
                    <div className="input-group-addon me-2 ">&#8377;</div>
                        <input type="number" onChange={handleminChange} name="mintot" value={mintotal} readOnly/>
                </div>
            </div>
          <button type="button" onClick={formSubmitmin} className="btn btn-primary mt-4">Submit</button>
        </div>
        </div>
       </form>
  </div>
</div>
 <h3 className="text-center mt-3" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-file-invoice-dollar" aria-hidden="true" style={{ color: 'red' }}></i>
      Payment Details
    </h3>
    <div className="table-responsive">
    <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Total Invoiced</th>
          <th>Advance Paid</th>
          <th>Available Balance</th>
          <th>Remaining Balance</th>
          <th>Advance Amount Used</th>
        </tr>
      </thead>
      <tbody>
        {totData.map((iptot, index) => (
          <tr >
            <td>{iptot.tot_invoiced}</td>
            <td>{iptot.tot_paid}</td>
            <td>{iptot.tot_balance}</td>
            <td>{iptot.remain_balance}</td>
            <td>{iptot.tot_used}</td>
          </tr>
        ))}
      </tbody>
    </table>
    </div>
    <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-file-invoice-dollar" aria-hidden="true" style={{ color: 'red' }}></i>
      Billing Summary
    </h3>
<div className="collapse " id="collapseMin">
  <div className="card card-body">
  <table className="erp-table-modern">
  <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>IP Bill Test</th>
          <th>Amount</th>
          <th>Invoiced</th>
        </tr>
  </thead>
  <tbody>
    {minviewData.map((min, index) => (
  <tr key={index}>
    <td>
      {min.min_test.split(',').map((item, idx) => (
        <div key={idx}>{item.trim()}</div>
      ))}
    </td>
     <td>
              {min.min_amount.split(',').map((amount, i) => (
                <React.Fragment key={i}>
                  {amount.trim()} * {min.min_units?.split(',')[i].trim()} =
                  {(parseFloat(amount.trim()) * parseFloat(min.min_units?.split(',')[i].trim()))}
                  {i < min.min_amount.split(',').length - 1 && <br />}
                </React.Fragment>
              ))}
            </td>
    <td>{min.min_tot}</td>
  </tr>
))}

    </tbody>
    </table>
  </div>
</div>
<p>
<button className="btn btn-info w-100 d-flex justify-content-between" type="button" data-bs-toggle="collapse" data-bs-target="#collapseMin" aria-expanded="false" aria-controls="collapseMin">
  <span className="text-start">+ IP Bill</span>
  <span className="text-end">Rs.{minviewTotalSum.toFixed(2)}</span>
</button>
</p>
<>
{labData && labData.length > 0 && (
    <>

<div className="collapse " id="collapseLab">
  <div className="card card-body">
  <table className="erp-table-modern">
  <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Lab Test</th>
          <th>Lab Amount</th>
          <th>Lab Invoiced</th>
          <th>Lab Paid</th>
          <th>Lab Balance</th>
        </tr>
  </thead>
  <tbody>
    {labData.map((lab, index) => (

          <tr key={index}>
            <td>
              {lab.lab_test.split(',').map((item, idx) => (
                <div key={idx}>{item.trim()}</div>
              ))}
            </td>
            <td>
              {lab.lab_amount.split(',').map((item, idx) => (
                <div key={idx}>{item.trim()}</div>
              ))}
            </td>
            <td>{lab.lab_tot}</td>
            <td>{lab.lab_paid}</td>
            <td>{lab.lab_balance}</td>
          </tr>
        ))}
    </tbody>
    </table>
  </div>
</div>
<p>
<button className="btn btn-info w-100 d-flex justify-content-between" type="button" data-bs-toggle="collapse" data-bs-target="#collapseLab" aria-expanded="false" aria-controls="collapseLab">
  <span className="text-start">+ Lab</span>
  <span className="text-end">Rs.{labTotalSum.toFixed(2)}</span>
</button>

</p>
</>
)}
</>
<>
{invData && invData.length > 0 && (
    <>
<div className="collapse " id="collapseInv">
  <div className="card card-body">
  <table className="erp-table-modern">
  <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Inv Test</th>
          <th>Inv Amount</th>
          <th>Inv Invoiced</th>
          <th>Inv Paid</th>
          <th>Inv Balance</th>
        </tr>
  </thead>
  <tbody>
    {invData.map((inv, index) => (
          <tr key={index}>
            <td>
              {inv.inv_test.split(',').map((item, idx) => (
                <div key={idx}>{item.trim()}</div>
              ))}
            </td>
            <td>
              {inv.inv_amount.split(',').map((item, idx) => (
                <div key={idx}>{item.trim()}</div>
              ))}
            </td>
            <td>{inv.inv_tot}</td>
            <td>{inv.inv_paid}</td>
            <td>{inv.inv_balance}</td>
          </tr>
        ))}
    </tbody>
    </table>
  </div>
</div>
<p>
<button className="btn btn-info w-100 d-flex justify-content-between" type="button" data-bs-toggle="collapse" data-bs-target="#collapseInv" aria-expanded="false" aria-controls="collapseInv">
  <span className="text-start">+ Radiology</span>
  <span className="text-end">Rs.{invTotalSum.toFixed(2)}</span>
</button>
</p>
</>
)}
</>
<>
{drugData && drugData.length > 0 && (
  <>
    <div className="collapse" id="collapseDrug">
      <div className="card card-body">
        <table className="erp-table-modern">
          <thead>
            <tr style={{ backgroundColor: '#1bc5ce', color: 'white' }}>
              <th>Drug</th>
              <th>Amount</th>
              <th>Invoiced</th>
              <th>Paid</th>
              <th>Balance</th>
            </tr>
          </thead>
          <tbody>
            {drugData.map((drug, index) => {
              const productArray = drug.product.split(',');
              const rows = productArray.map((test, subIndex) => {
                const pharmData = viewPharmData.find((data) => data.id == test);
                const isFirstRow = subIndex === 0;
                const rowspan = isFirstRow ? productArray.length : undefined;

                return (
                  <tr key={`${index}-${subIndex}`} style={{ border: "1px solid", borderColor: "#2194d9" }}>
                    <td>{pharmData?.product.product}</td>
                    <td>{pharmData?.product.uamount}</td>
                    {isFirstRow && <td rowSpan={rowspan}>{drug.total}</td>}
                    {isFirstRow && <td rowSpan={rowspan}>{drug.paid}</td>}
                    {isFirstRow && <td rowSpan={rowspan}>{drug.balance}</td>}
                  </tr>
                );
              });
              return rows;
            })}
          </tbody>
        </table>
      </div>
    </div>
    <p>
      <button className="btn btn-info w-100 d-flex justify-content-between" type="button" data-bs-toggle="collapse" data-bs-target="#collapseDrug" aria-expanded="false" aria-controls="collapseDrug">
        <span className="text-start">+ Drug</span>
        <span className="text-end">Rs.{drugTotalSum.toFixed(2)}</span>
      </button>
    </p>
  </>
)}
</>
    <h4 style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', justifyContent: 'space-between' }}>
      <span style={{ alignSelf: 'flex-start' }}>Total Invoiced</span>
      <span style={{ alignSelf: 'flex-end' }}>Rs.{InvoicedTotal.toFixed(2)}</span>
    </h4>
    <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-file-invoice-dollar" aria-hidden="true" style={{ color: 'red' }}></i>
      Payment/Invoice List
    </h3>
    <div className="table-responsive">
  <table className="erp-table-modern">
  <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Test</th>
          <th>Invoice</th>
          <th>Invoice Amount</th>
          <th>Paid</th>
          <th>Balance</th>
          <th>Mode</th>
        </tr>
  </thead>
  <tbody>
    {advData.map((adv, index) => (
          <tr >
            <td>{adv.adv_type}</td>
            <td><Link to={`/ip-invoice/${adv.invoice}`} target="_blank">{adv.invoice}</Link></td>
            <td>{adv.advance}</td>
            <td>{adv.paid}</td>
            <td>{adv.balance}</td>
            <td>{adv.mode}</td>
          </tr>
    ))}
            {drugData.map((drug, index) => {
              const productArray = drug.product.split(',');
              const rows = productArray.map((test, subIndex) => {
                const pharmData = viewPharmData.find((data) => data.id == test);
                const isFirstRow = subIndex === 0;
                const rowspan = isFirstRow ? productArray.length : undefined;

                return (
                  <tr key={`${index}-${subIndex}`} style={{ border: "1px solid", borderColor: "#2194d9" }}>
                    <td>{pharmData?.product.product}</td>
                    <td>{pharmData?.product.uamount}</td>
                    {isFirstRow && <td rowSpan={rowspan}>{drug.total}</td>}
                    {isFirstRow && <td rowSpan={rowspan}>{drug.paid}</td>}
                    {isFirstRow && <td rowSpan={rowspan}>{drug.balance}</td>}
                    {isFirstRow && <td rowSpan={rowspan}>{drug.mode}</td>}
                  </tr>
                );
              });
              return rows;
            })}
    {labData.map((lab, index) => (
       lab.lab_paid > 0 ? (
          <tr >
            <td>{lab.lab_test}</td>
            <td><Link to={`/lab-invoice-ip/${lab.lab_invoice}`} target="_blank">{lab.lab_invoice}</Link></td>
            <td>{lab.lab_tot}</td>
            <td>{lab.lab_paid}</td>
            <td>{lab.lab_balance}</td>
            <td>{lab.lab_pmode}</td>
          </tr>
       ) : null
    ))}
    {invData.map((inv, index) => (
       inv.inv_paid > 0 ? (
          <tr >
            <td>{inv.inv_test}</td>
            <td><Link to={`/inv-invoice-ip/${inv.inv_invoice}`} target="_blank">{inv.inv_invoice}</Link></td>
            <td>{inv.inv_tot}</td>
            <td>{inv.inv_paid}</td>
            <td>{inv.inv_balance}</td>
            <td>{inv.inv_pmode}</td>
          </tr>
       ) : null
    ))}
    {minviewData.map((min, index) => (
          <tr >
            <td>{min.min_test}</td>
            <td></td>
            <td>{min.min_tot}</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
    ))}
    {totData.map((row, index) => (
      row.tot_disc > 0 ? (
        <tr key={index}>
          <td>Discount Amount</td>
          <td></td>
          <td>{row.tot_disc}</td>
          <td></td>
          <td></td>
          <td>{row.disc_reason}</td>
        </tr>
      ) : null
    ))}
    </tbody>
    </table>
    </div>
    <>
   {insurData && insurData.length > 0 && (
    <>
    <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-file-invoice-dollar" aria-hidden="true" style={{ color: 'red' }}></i>
      Insurance Details
    </h3>
    <div className="table-responsive">
  <table className="erp-table-modern">
  <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Insurance Type</th>
          <th>Claim Date</th>
          <th>CCN No</th>
          <th>Claimed By</th>
          <th>Est Amount</th>
          <th>Pending Amount</th>
          <th>Approved Amount</th>
          <th>Reason</th>
        </tr>
  </thead>
  <tbody>
    {insurData.map((ins, index) => {
            const pdamt = parseFloat(ins.est_amount-ins.app_amount);
            const instype = ipData.map(row => row.insur_cmpy.company);
          return (
            <tr key={index}>
            <td>{instype}</td>
            <td>{ins.ccn}</td>
            <td>{ins.app_date}</td>
            <td>{ins.addedby}</td>
            <td>{ins.est_amount}</td>
            <td>{pdamt}</td>
            <td>{ins.app_amount}</td>
            <td>{ins.reason}</td>
          </tr>
          );
    })}
    </tbody>
    </table>
    </div>
    </>
    )}
    </>
    <>
    {iprefundData && iprefundData.length > 0 && (
    <>
    <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-file-invoice-dollar" aria-hidden="true" style={{ color: 'red' }}></i>
      Refund Details
    </h3>
    <div className="table-responsive">
  <table className="erp-table-modern">
  <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Refund Type</th>
          <th>Refund Amount</th>
          <th>Receipt</th>
          <th>Received By</th>
          <th>Reason</th>
        </tr>
  </thead>
  <tbody>
    {iprefundData.map((ref, index) => (
          <tr>
            <td>{ref.refund_type}</td>
            <td>{ref.refund_amount}</td>
            <td><Link to={`/refund-invoice-ip/${ref.receipt}`} target="_blank">{ref.receipt}</Link></td>
            <td>{ref.receivedby}</td>
            <td>{ref.reason}</td>
          </tr>
    ))}
    </tbody>
    </table>
    </div>
    </>
    )}
    </>

    <h4 style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', justifyContent: 'space-between' }}>
      <span style={{ alignSelf: 'flex-start' }}>Net Payment Amount</span>
      <span style={{ alignSelf: 'flex-end' }}>Rs.{PaidTotal.toFixed(2)}</span>
    </h4>
    <p>
<button className="btn btn-info  d-flex justify-content-between" type="button" data-bs-toggle="collapse" data-bs-target="#collapseDis" aria-expanded="false" aria-controls="collapseDis">
  <span className="text-start">+ Discount</span>
</button>
</p>
<div className="collapse" id="collapseDis">
  <div className="card card-body">
  <form>
  <div className="table-responsive">
  <table className="erp-table-modern">
  <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Discount %</th>
          <th>Discount Amount</th>
          <th>Reason</th>
          <th>Action</th>
        </tr>
  </thead>
  <tbody>
          <tr >
            <td>
            <input type="number" onChange={handledisChange} name="disPer" id="disPer" value={disPer} />
            </td>
            <td>
            <input type="number" onChange={handledisChange} name="disAmount" id="disAmount" value={disAmount} max={parseFloat(PaidTotal)} />
            </td>
            <td>
            <input type="text" onChange={handledisChange} name="reason" id="reason" />
            </td>
            <td>
             <button type="button" onClick={discountHandler} className="btn btn-success">Save</button>
            </td>
          </tr>
    </tbody>
    </table>
    </div>
    </form>
  </div>
</div>
    <h4 style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', justifyContent: 'space-between' }}>
      <span style={{ alignSelf: 'flex-start' }}>Balance Amount</span>
      <span style={{ alignSelf: 'flex-end' }}>Rs.{BalanceTotal.toFixed(2)}</span>
    </h4>
{BalanceTotal >0 && (
<>
    <p>
<button className="btn btn-danger  d-flex justify-content-between" type="button" data-bs-toggle="collapse" data-bs-target="#collapseRef" aria-expanded="false" aria-controls="collapseRef">
  <span className="text-start">+ Refund</span>
</button>
</p>
<div className="collapse" id="collapseRef">
  <div className="card card-body">
  <form>
  <div className="table-responsive">
  <table className="erp-table-modern">
  <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Refund Type</th>
          <th>Refund Amount</th>
          <th>Reason</th>
          <th>Action</th>
        </tr>
  </thead>
  <tbody>
          <tr>
            <td>
            <select className="form-control" name="ref_type" id="ref_type">
              <option value="Discharge Settlement">Discharge Settlement</option>
              <option value="Cancel Against Invoice">Cancel Against Invoice</option>
              <option value="Others">Others</option>
            </select>
            </td>
            <td>
            <input type="number" name="refAmount" id="refAmount" />
            </td>
            <td>
            <input type="text" name="ref_reason" id="ref_reason" />
            </td>
            <td>
             <button type="button" onClick={refundHandler} className="btn btn-success">Save</button>
            </td>
          </tr>
    </tbody>
    </table>
    </div>
    </form>
  </div>
</div>
</>
)}
    <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-file-invoice-dollar" aria-hidden="true" style={{ color: 'red' }}></i>
      Discharge Detail
    </h3>
{discharge_status == 1 ? (
  <div style={{
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

}}>
  <span style={{
    color: 'white',
    backgroundColor: 'green',
    padding: '10px',
    borderRadius: '5px',
    fontWeight: 'bold',
    display: 'inline-block',
    margin: '10px 0'
  }}>
    Patient Discharged
  </span>
</div>


) : (
  <form>
    <div className="row mt-4">
      <div className="col-md-3 mb-3">
        <label htmlFor="Discharge type" className="form-label">Discharge Type</label>
        <select className="form-control" name="discharge_type" id="discharge_type">
          <option value="Regular">Regular</option>
          <option value="Death">Death</option>
          <option value="Against medical">Against Medical Advice</option>
          <option value="Absconding">Absconding</option>
          <option value="Emergency">Emergency Discharge</option>
        </select>
      </div>
      <div className="col-md-3 mb-3">
        <label htmlFor="Date" className="form-label">Discharge Date</label>
        <DatePicker
          className="form-control"
          name="discharge_time"
          id="discharge_time"
          selected={selectedDateTime}
          onChange={handleDateTimeChange}
          dateFormat="yyyy-MM-dd h:mm"
          showTimeSelect
          timeIntervals={15}
          timeCaption="Time"
        />
      </div>
      <div className="col-md-3 mt-4">
        <button type="button" onClick={dischargeHandler} className="btn btn-success">Discharge</button>
      </div>
    </div>
  </form>

)}

    </section>
    )
}

export default IpPatView;